import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AuthForm from './AuthForm';
import { notify } from '../Shared/toast';

export default function Signup() {
  const [formData] = useState({ /* ... */ });
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await new Promise((resolve) => {
        setTimeout(resolve, 1000);
      });
      login(formData);
      navigate('/');
    } catch (error) {
      notify.error('Signup error:', error);
    }
  };

  return (
    <AuthForm type="signup" onSubmit={handleSubmit}>
      {/* Form fields */}
    </AuthForm>
  );
}
